import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgExpandIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M47.337 12.8H36.8V9.6h10.537a3.2 3.2 0 0 1 2.263.937l3.862 3.863c.6.6.938 1.414.938 2.263V27.2h-3.2V16.663l-.8-.8L36.33 29.93l-2.263-2.262L48.137 13.6zM13.6 48.137l-.8-.8V36.8H9.6v10.537a3.2 3.2 0 0 0 .937 2.263l3.863 3.863a3.2 3.2 0 0 0 2.262.937H27.2v-3.2H16.662l-.8-.8 14.069-14.068-2.263-2.264z"
    />
  </svg>
)
export default SvgExpandIcon
